import { Link } from 'react-router-dom';

const entries = [
  {
    to: '/category?type=movie',
    title: '电影',
    desc: '院线佳作与独立影像，剧情、悬疑、科幻一网打尽',
    count: '120+ 部',
    image:
      'https://readdy.ai/api/search-image?query=Moody%20cinema%20hall%20with%20rows%20of%20seats%20and%20a%20glowing%20screen%2C%20deep%20navy%20shadows%20with%20warm%20amber%20accent%20light%2C%20cinematic%20minimalist%20composition%2C%20high%20detail&width=800&height=600&seq=cat-movie&orientation=landscape',
    icon: 'ri-film-line',
  },
  {
    to: '/category?type=series',
    title: '电视剧',
    desc: '都市、年代与悬疑剧集，陪你度过一个个长夜',
    count: '85+ 部',
    image:
      'https://readdy.ai/api/search-image?query=Cozy%20dark%20living%20room%20with%20a%20glowing%20television%20and%20warm%20lamp%20light%20at%20night%2C%20navy%20tones%20with%20amber%20accents%2C%20cinematic%20minimalist%20composition%2C%20high%20detail&width=800&height=600&seq=cat-series&orientation=landscape',
    icon: 'ri-tv-2-line',
  },
];

export default function CategoryEntry() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-8 -mt-10 md:-mt-14 relative z-20">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        {entries.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className="group relative h-44 md:h-52 rounded-lg overflow-hidden border border-background-200 cursor-pointer"
          >
            <img
              src={item.image}
              alt={`${item.title}分类封面`}
              title={`${item.title}分类 - 姐姐的朋友影视内容站`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 to-primary-950/30" />
            <div className="absolute inset-0 p-5 md:p-7 flex flex-col justify-center">
              <span className="flex items-center justify-center w-11 h-11 rounded-md bg-accent-500 text-primary-950 mb-3">
                <i className={`${item.icon} text-xl`} />
              </span>
              <h3 className="font-heading font-bold text-2xl text-background-50 mb-1">{item.title}</h3>
              <p className="text-sm text-background-100/80 max-w-sm mb-3">{item.desc}</p>
              <span className="flex items-center gap-1 text-xs font-medium text-accent-400">
                {item.count}
                <i className="ri-arrow-right-line" />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}